import { render, staticRenderFns } from "./bodyFunctionAdd.vue?vue&type=template&id=0f2afcdc&scoped=true"
import script from "./bodyFunctionAdd.vue?vue&type=script&lang=js"
export * from "./bodyFunctionAdd.vue?vue&type=script&lang=js"
import style0 from "./bodyFunctionAdd.vue?vue&type=style&index=0&id=0f2afcdc&prod&lang=scss&scoped=true"
import style1 from "./bodyFunctionAdd.vue?vue&type=style&index=1&id=0f2afcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2afcdc",
  null
  
)

export default component.exports